import Vue from "vue";
import i18n from "../../../i18n";

// let noopPV = { pId : null, vId : null }

export default {
  async createCable({ commit }, payload) {
    return Vue.axios.post(Vue.$url("cable"), payload).then((rsp) => {
      Vue.$log.debug("cable created and saved under", rsp.data.id);
      commit("mShowInfoMessage", i18n.t("common.saved", { 0: "Cable", 1: payload.description }), { root: true });
    });
  },

  async fetchCables({ commit }, { pId, vId, pvId }) {
    Vue.$log.debug("loading cables for", pId, vId);

    let query = "?pId=" + (pId || "") + "&vId=" + (vId || "") + "&pvId=" + (pvId || "");
    return Vue.axios.get(Vue.$url("cable" + query)).then((rsp) => commit("SET_CABLES", rsp.data));
  },

  async fetchLines({ commit }, { pId, vId }) {
    Vue.$log.debug("loading lines for", pId, vId);

    return Vue.axios.get(Vue.$url("line")).then((rsp) => commit("SET_LINES", rsp.data));
  },

  async fetchNextMaxCode({ commit }, { pId, vId }) {
    Vue.$log.debug("loading cable next code for", pId, vId);

    let query = "?pId=" + (pId || "") + "&vId=" + (vId || "");
    return Vue.axios.get(Vue.$url("cable/max-code" + query)).then((rsp) => {
      commit("SET_NEXT_SEQ_CODE", rsp.data);
      return rsp.data;
    });
  },

  async deleteCable({ commit }, payload) {
    Vue.$log.debug("trying to delete Cable", payload.id);

    return Vue.axios.delete(Vue.$url("cable/" + payload.id)).then(() => {
      commit("mShowInfoMessage", i18n.t("common.lockupdate", { 0: payload.description }), { root: true });
    });
  },

  async updateLine({ commit }, payload) {
    return Vue.axios.put(Vue.$url("line/" + payload.id), payload).then(() => {
      commit("mShowInfoMessage", i18n.t("common.updated", { 0: "Line", 1: payload.description }), { root: true });
    });
  },

  async updateCable({ commit }, payload) {
    return Vue.axios.put(Vue.$url("cable/" + payload.id), payload).then(() => {
      commit("mShowInfoMessage", i18n.t("common.updated", { 0: "Cable", 1: payload.description }), { root: true });
    });
  },
};
